import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Notify from '@/components/Notification';
import { MAX_SIZE_BYTES } from '@/helpers/constants';
import Icon from './assets/icon.svg';
import { FilePreview } from './file';
import s from './index.module.scss';

export const UploadField = ({ name, value, dropLabel, onChange, error }) => {
  const { t } = useTranslation('components');
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: acceptedFiles => {
      const validFiles = [];
      acceptedFiles.forEach(file => {
        if (file.size === 0) {
          Notify.error({ text: t('upload_field.empty_file', { fileName: file.name }) });
        } else {
          validFiles.push(file);
        }
      });
      onChange([...value, ...validFiles]);
    },
    multiple: true,
    accept: {
      'application/pdf': ['.pdf'],
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
    },
    maxSize: MAX_SIZE_BYTES,
    onDropRejected: fileRejections => {
      fileRejections.forEach(rejection => {
        rejection.errors.forEach(error => {
          if (error.code === 'file-too-large') {
            Notify.error({
              text: t('upload_field.file_too_large', { fileName: rejection.file.name }),
            });
          } else if (error.code === 'file-invalid-type') {
            Notify.error({
              text: t('upload_field.invalid_file_type', { fileName: rejection.file.name }),
            });
          }
        });
      });
    },
  });

  const onRemove = indexToRemove => {
    const updatedFiles = value.filter((_, index) => index !== indexToRemove);
    onChange(updatedFiles);
  };

  return (
    <div className={s.wrapper}>
      <div className={classnames(s.dropzone, error && s.dropzone_error)} {...getRootProps()}>
        <input {...getInputProps()} name={name} />
        <div className={s.dropzone_inner}>
          <img src={Icon} alt="icon" width={24} height={24} />
          {isDragActive ? (
            <p>{t('upload_field.drop_files_here')}</p>
          ) : (
            <p>
              {dropLabel || t('upload_field.drop_or_select')}{' '}
              <span style={{ cursor: 'pointer' }}>{t('upload_field.select')}</span>
            </p>
          )}
        </div>
      </div>
      {value && value.length > 0 && (
        <div className={s.files}>
          {value.map((file, index) => (
            <FilePreview
              key={index}
              name={file.name}
              size={(file.size / 1024).toFixed(1)}
              onRemove={() => onRemove(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
